import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=20c88c2c&scoped=true"
import script from "./ProductCard.vue?vue&type=script&lang=ts"
export * from "./ProductCard.vue?vue&type=script&lang=ts"
import style0 from "./ProductCard.vue?vue&type=style&index=0&id=20c88c2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c88c2c",
  null
  
)

export default component.exports